import { React, useState } from 'react';
import Header from './Components/Header';
import Help from './Components/Help';
import Login from './Components/Login';
import Scenary from './Components/Scenary';
import useStateWithSessionStorage from './Hooks/useStateWithSessionStorage';
import './App.scss';

function App() {
  const [user, setCurrentUser] = useStateWithSessionStorage('draw-user');
  const [step, setStep] = useState(0);

  return (
    <div className='game-container'>
      <div className='game'>
        <Header />
        <div className={`wrapper ${step === 0 ? 'wrapper--centered' : ''}`}>
          <Login user={user} setCurrentUser={setCurrentUser} />
          <Help user={user} step={step} setStep={setStep} />
          <Scenary user={user} step={step} setStep={setStep} />
        </div>
      </div>
    </div>
  );
}

export default App;
